interface Props {
  count?: number;
}

export default function ReportRowSkeleton({ count = 5 }: Props) {
  return (
    <div className="Moderation__List" aria-hidden="true">
      {Array.from({ length: count }, (_, i) => (
        <div
          key={i}
          data-testid="report-row-skeleton"
          className="Moderation__Row Moderation__RowSkeleton"
        >
          <span className="Moderation__RowSkeleton__Chip" />
          <span className="Moderation__RowSkeleton__Line" />
          <span className="Moderation__RowSkeleton__Meta" />
        </div>
      ))}
    </div>
  );
}
